import React from "react";

interface NavBarProps {
  //
}

const NavBar: React.FC<NavBarProps> = () => (
  <nav
    className="navbar navbar-expand-lg bg-secondary fixed-top text-uppercase"
    id="mainNav"
  >
    <div className="container">
      <a className="navbar-brand js-scroll-trigger" href="#page-top">
        Hillary Kimaita
      </a>
      <button
        className="navbar-toggler navbar-toggler-right text-uppercase bg-primary text-white rounded"
        type="button"
        data-toggle="collapse"
        data-target="#navbarResponsive"
        aria-controls="navbarResponsive"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <i className="fas fa-bars"></i>
      </button>
      <div className="collapse navbar-collapse" id="navbarResponsive">
        <ul className="navbar-nav ml-auto">
          <li className="nav-item mx-0 mx-lg-1">
            <a
              className="nav-link py-3 px-0 px-lg-3 rounded js-scroll-trigger"
              href="#what"
            >
              What
            </a>
          </li>
          <li className="nav-item mx-0 mx-lg-1">
            <a
              className="nav-link py-3 px-0 px-lg-3 rounded js-scroll-trigger"
              href="#work"
            >
              Work
            </a>
          </li>
          <li className="nav-item mx-0 mx-lg-1">
            <a
              className="nav-link py-3 px-0 px-lg-3 rounded js-scroll-trigger"
              href="#about"
            >
              Who
            </a>
          </li>
          <li className="nav-item mx-0 mx-lg-1">
            <a
              className="nav-link py-3 px-0 px-lg-3 rounded js-scroll-trigger"
              href="#education"
            >
              Education
            </a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
);

export default NavBar;
